function salesInitiate() {
  //code for comm100 open on sales chat click
  let height = $("#chat_window_container")
    .contents()
    .height();
  console.log(height);
  if (height != null) {
    console.log("chat is open");

    if (height < 250) {
      console.log("now run maximize chat window code");
      $("#chat_window_container")
        .contents()
        .find("a.chatButton")[0]
        .click();
      //$("#support-chat-wrapper").removeClass("open-chat");
    }
  } else {
    console.log("run chat window open code");
    $("#comm100-container")
      .find("a")[0]
      .click();
    //$("#support-chat-wrapper").removeClass("open-chat");
  }
}

window.salesInitiate = salesInitiate;